import { hasNarrativePlaceholder } from './narrativeTemplate';

/**
 * Tipos de "grafico" que no tienen consulta SQL propia: solo su propia configuracion
 * (label + un par de campos). Todo lo que los crea/edita pasa por el mismo editor de
 * gráficos que el resto, asi que este set se usa tanto en ChartBuilderDialog (para
 * saltarse la parte de query/SQL) como en ChartGrid/App (para saber cuando un chart
 * no tiene queryId por diseño, no por error).
 */
export const QUERYLESS_CHART_TYPES = new Set(['button', 'weather', 'calendar']);

/**
 * 'narrative' es queryless solo en su variante de texto fijo (sin {{marcadores}}): no lee
 * ninguna columna, así que no necesita consulta ni modelo de datos activo, a diferencia de un
 * narrativo con marcadores (que sí agrupa datos reales, igual que Barras). `context.narrativeTemplate`
 * es la plantilla actual (editor) o guardada (`chart.advancedConfig.template`).
 */
export function isQuerylessChartType(type, context) {
  if (QUERYLESS_CHART_TYPES.has(type)) return true;
  if (type === 'narrative') {
    const template = context?.narrativeTemplate || '';
    return Boolean(template.trim()) && !hasNarrativePlaceholder(template);
  }
  return false;
}

/** Solo http/https: evita que un link guardado use javascript:/data: (XSS). */
export function isSafeButtonUrl(value) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return false;
  try {
    const url = new URL(trimmed);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}
